import { config } from "@/lib/config";
import { Button } from "@donex/ui";

function SlackIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <rect width="3" height="8" x="13" y="2" rx="1.5" />
      <path d="M19 8.5V10h1.5A1.5 1.5 0 1 0 19 8.5" />
      <rect width="3" height="8" x="8" y="14" rx="1.5" />
      <path d="M5 15.5V14H3.5A1.5 1.5 0 1 0 5 15.5" />
      <rect width="8" height="3" x="14" y="13" rx="1.5" />
      <path d="M15.5 19H14v1.5a1.5 1.5 0 1 0 1.5-1.5" />
      <rect width="8" height="3" x="2" y="8" rx="1.5" />
      <path d="M8.5 5H10V3.5A1.5 1.5 0 1 0 8.5 5" />
    </svg>
  );
}

export default function OnboardingPage() {
  return (
    <div className="flex h-screen flex-col bg-background text-foreground">
      <div className="pointer-events-none fixed inset-0 overflow-hidden">
        <div className="absolute -top-40 -left-32 h-[480px] w-[480px] rounded-full bg-primary/10 blur-3xl" />
        <div className="absolute top-1/3 -right-40 h-[420px] w-[420px] rounded-full bg-accent/5 blur-3xl" />
      </div>

      <main className="relative flex flex-1 flex-col items-center justify-center px-6 py-16">
        <div className="flex max-w-md flex-col items-center gap-6 text-center">
          <div
            className="flex h-16 w-16 items-center justify-center rounded-2xl text-primary-foreground"
            style={{ backgroundImage: "var(--gradient-primary)" }}
          >
            <SlackIcon className="h-8 w-8" />
          </div>

          <div className="flex flex-col gap-2">
            <h1 className="text-3xl font-semibold tracking-tight sm:text-4xl">
              Welcome to{" "}
              <span
                className="bg-clip-text text-transparent"
                style={{ backgroundImage: "var(--gradient-primary)" }}
              >
                done[x]
              </span>
            </h1>
            <p className="text-sm text-muted-foreground">
              Connect your Slack workspace to start sending interactive messages with custom actions
              and blocks.
            </p>
          </div>

          <Button
            asChild
            size="lg"
            className="text-primary-foreground"
            style={{ backgroundImage: "var(--gradient-primary)" }}
          >
            <a href={`${config.apiBaseUrl}/slack/install`}>
              <SlackIcon className="h-5 w-5" /> Add to Slack Workspace
            </a>
          </Button>
        </div>
      </main>
    </div>
  );
}
